<template>
  <el-card>
    <div class="head flex row-between m-b-22">
      <div class="title">评审结果</div>
      <slot name="headAction"></slot>
    </div>

    <template v-if="list.length > 0">
      <el-table :data="list" border>
        <el-table-column
          label="投标单位"
          align="center"
          prop="supplierName"
          fixed
        />
        <el-table-column
          :label="`报价总金额(${offerUnit})`"
          prop="offerPrice"
          align="center"
          show-tooltip-when-overflow
        />
        <template v-for="item in reviewList">
          <el-table-column
            v-if="showReviewWay(item)"
            :key="item.wayType"
            :label="inquiryReviewTypeDict().translate(item.wayType).label"
            align="center"
            show-tooltip-when-overflow
          >
            <template slot-scope="{ row }">
              <span>{{ findScore(item, row).label }}</span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="评审总分" align="center" prop="summarySore" />
        <el-table-column label="排序" align="center" prop="orderNum">
          <template slot-scope="{ row }">
            <span>{{ row.rankNum }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-button
        v-if="hasReport"
        type="text"
        class="m-t-8"
        @click="toReviewReport"
      >
        查看报告
      </el-button>
    </template>

    <div v-else class="empty">
      <img
        :src="require('@/assets/images/empty/list_no_content.png')"
        style="width: 184px; height: 150px"
        alt=""
      />
      <p>未完成线上评审，暂无数据</p>
    </div>

    <jczh-drawer
      title="评标报告"
      :visible.sync="reportVisible"
      size="100%"
      :el-attrs="{
        destroyOnClose: true
      }"
      @close="reportVisible = false"
    >
      <template v-slot:content>
        <online-review-report-preview :review-project="reviewProject" />
      </template>
      <template slot="footer">
        <el-button type="primary" @click="reportVisible = false">
          关 闭
        </el-button>
      </template>
    </jczh-drawer>
  </el-card>
</template>

<script>
import OnlineReviewReportPreview from '@/components/online-review/review/OnlineReviewReportPreview'
import { workbenchServiceDict } from '@/dictionary/system'
import { mapState } from 'vuex'
import { getInquiryReviewRankPageApi } from '@/api/procure/inquiry-review'
import {
  inquiryReviewTypeDict,
  onlineReviewMethodDict
} from '@/dictionary/project/online-review'
import { purchaseTypeDict } from '@/dictionary/project/common'
import { sortBy } from 'lodash'
import { toReviewOnlineHall } from '@/utils/platform'

/**
 * @description 评审结果
 */
export default {
  name: 'InquiryReviewResult',

  components: { OnlineReviewReportPreview },

  props: {
    reviewId: {
      type: [String, Number],
      default: ''
    },

    reviewList: {
      type: Array,
      default: () => []
    },

    reviewClosed: {
      type: Boolean,
      default: false
    },

    // 报价币种
    offerUnit: {
      type: String,
      default: '元'
    },

    hasReport: {
      type: Boolean,
      default: false
    },

    isRankByQuote: {
      type: Boolean,
      default: false
    },

    purchaseType: {
      type: [Number, String],
      default: purchaseTypeDict.INQUIRY.value
    },

    showPdfDialog: {
      type: Boolean,
      default: false
    },

    resultApi: {
      type: Function,
      default: getInquiryReviewRankPageApi
    },

    reviewProject: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      onlineReviewMethodDict,

      list: [],

      reportVisible: false
    }
  },

  computed: {
    ...mapState('router', ['currentWorkbench']),

    orderId() {
      return this.$route.params.orderId
    },

    // 代理机构加上Agency
    entrustRouter() {
      if (this.currentWorkbench === workbenchServiceDict.AGENCY.value) {
        return 'Agency'
      }
      return ''
    }
  },

  created() {
    this.getReviewSummaryList()
  },

  methods: {
    inquiryReviewTypeDict() {
      return inquiryReviewTypeDict
    },
    getReviewSummaryList() {
      this.resultApi(this.reviewId, {
        orderId: this.orderId,
        isListing: 1
      })
        .then(res => {
          this.list = sortBy(res.data?.records || [], 'rankNum')
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },

    findScore(reviewWay, row) {
      const summaryItemList = row?.summaryItems
        ? JSON.parse(row?.summaryItems)
        : []
      const reviewWayScore =
        summaryItemList.find(item => item.wayId === reviewWay?.wayId) || {}
      if (reviewWay.reviewMethod === onlineReviewMethodDict.PASS.value) {
        reviewWayScore.label = '通过'
      } else {
        reviewWayScore.label = reviewWayScore.score || '-'
      }
      return reviewWayScore
    },

    toReviewReport() {
      if (this.showPdfDialog) {
        this.reportVisible = true
        return
      }
      toReviewOnlineHall({
        page: 'ReviewOnlineReport',
        reviewId: this.reviewId,
        orderId: this.orderId,
        purchaseType: purchaseTypeDict.INQUIRY.value
      })
    },

    showReviewWay(item) {
      // 如果是最低价法，则不显示所有评审
      if (this.isRankByQuote) {
        return false
      }
      // 任何评审都不显示初步评审
      if (item.wayType === inquiryReviewTypeDict.QUALIFICATION.value) {
        return false
      }
      return true
    }
  }
}
</script>

<style scoped lang="scss">
.title {
  font-size: 16px;
  color: $text-color;
}

.button-green {
  background: #13c2c2;
  color: $white-color;
}

.empty {
  text-align: center;

  p {
    color: $second-text-color;
    margin-top: 16px;
  }
}
</style>
